import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { ISubscriptions, IProductsState } from '../type';
import { AppDispatch } from 'stores';
import { Region } from 'stores/type';
import { getProductList } from 'helpers/api';

export const initialState: IProductsState = {
    region: Region.AU,
    isError: false,
    isLoading: true,
    productList: [],
    error: null,
};

const slice: Slice<IProductsState> = createSlice({
    name: 'products',
    initialState,
    reducers: {
        fetchRequested: state => ({
            ...state,
            isLoading: true,
            isError: false,
            error: null,
        }),
        fetchSucceeded: (state, action: PayloadAction<ISubscriptions>) => {
            const { subscriptions } = action.payload;
            return {
                ...state,
                isLoading: false,
                isError: false,
                error: null,
                productList: subscriptions?.length > 0 ? subscriptions : [],
            };
        },
        fetchFailed: (state, action: PayloadAction<AxiosError>) => ({
            ...state,
            isLoading: false,
            isError: true,
            error: {
                status: action.payload?.response?.status,
                message: action.payload?.response?.data.message,
            },
        }),
        saveRegion: (state, action: PayloadAction<Region>) => ({
            ...state,
            region: action.payload,
        }),
    },
});

export const { fetchRequested, fetchSucceeded, fetchFailed, saveRegion } = slice.actions;

const isNZTimezone = (timezone: string): boolean => {
    switch (timezone) {
        case 'Pacific/Auckland':
            return true;
        case 'NZ':
            return true;
        case 'NZ-CHAT':
            return true;
        default:
            return false;
    }
};

export const fetchRegion = (): Region => {
    const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const region: Region = isNZTimezone(timezone) ? Region.NZ : Region.AU;
    return region;
};

export const fetchProductList = () => {
    return (dispatch: AppDispatch) => {
        dispatch(fetchRequested(undefined));

        const region = fetchRegion();
        dispatch(saveRegion(region));

        getProductList()
            .then(res => {
                dispatch(fetchSucceeded(res.data));
            })
            .catch(err => {
                dispatch(fetchFailed(err));
            });
    };
};

export default slice.reducer;
